import { useEffect, useState } from 'react';
import { lf, version } from 'storage/localForage';

const useUpdateDatabase = () => {
  const [updated, setUpdated] = useState(false);
  const databaseSetup = async () => {
    const value = await lf.getItem('version');
    if (value !== version) {
      await lf.clear();
      console.log('cleared');
      await lf.setItem('version', version);
      console.log('set new version');
      setUpdated(true);
    }
    setUpdated(false);
  };

  useEffect(() => {
    databaseSetup().catch((e) => {
      console.error(e);
    });
  }, []);

  return [updated, setUpdated];
};

export default useUpdateDatabase;
